module.exports = __webpack_public_path__ + "static/media/7.f07b3f3b.svg";